export const PLACEHOLDER_PATTERN = /\{([^}]+)\}/g;

export function getPlaceholderNames(text: string): string[] {
  return [...text.matchAll(PLACEHOLDER_PATTERN)]
    .map(m => m[1])
    .filter((name): name is string => name !== undefined);
}
